import { render, staticRenderFns } from "./GruposContatosTabela.vue?vue&type=template&id=5d154d06"
import script from "./GruposContatosTabela.vue?vue&type=script&lang=js"
export * from "./GruposContatosTabela.vue?vue&type=script&lang=js"
import style0 from "./GruposContatosTabela.vue?vue&type=style&index=0&id=5d154d06&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports